import { Notification as InnerNotification, info } from './notification';
const Notification = InnerNotification;
Notification.info = info;
export default Notification;
